"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.customerAgreementsTableConf = void 0;
var end2end_1 = require("@hudled/end2end");
var FooterCounterWithWord_1 = __importDefault(require("containers/TableMaker/components/FooterCounterWithWord"));
var constants_1 = require("containers/TableMaker/constants");
var populatedDerived_1 = require("utils/selectors/populatedDerived");
var ActionsDropdown_1 = __importDefault(require("./CellComponents/ActionsDropdown"));
var AgreementStatus_1 = __importDefault(require("./CellComponents/AgreementStatus"));
var StatusCounter_1 = __importDefault(require("./CellComponents/StatusCounter"));
var AddChargeForCustomerModal_1 = __importDefault(require("./Modals/AddChargeForCustomerModal"));
var CancelAgreement_1 = __importDefault(require("./Modals/CancelAgreement"));
var ResendAgreement_1 = __importDefault(require("./Modals/ResendAgreement"));
var utils_1 = require("./utils");
var // XL, LG, MD, SM, XS,
XL = constants_1.CellSize.XL, LG = constants_1.CellSize.LG, XSM = constants_1.CellSize.XSM;
var agreementStatusOrder = [
    'scheduled', 'sent', 'opened_by_copy_link', 'opened_by_email', 'opened_by_all', 'accepted',
];
exports.customerAgreementsTableConf = {
    modals: {
        cancelAgreement: CancelAgreement_1.default,
        addCharge: AddChargeForCustomerModal_1.default,
        resendAgreement: ResendAgreement_1.default,
    },
    headersMap: {
        name: 'Customer',
        clientDiscountSplit: 'Client Discount',
        primaryContactName: 'Contact Person',
        primaryContactEmail: '',
        organizationsCount: 'Organizations',
        agreementDate: 'Date',
    },
    config: {
        selector: populatedDerived_1.selectAgreementCustomers,
        defaultSort: { key: 'name', order: 1 },
    },
    row: { hoverable: true },
    extractors: {
        primaryContactName: function (item) { return item.primaryContactName || item.primaryContactEmail; },
        primaryContactEmail: function (item) { return item.primaryContactName ? item.primaryContactEmail : ''; },
        organizationsCount: function (item) { var _a, _b; return (_b = (_a = item.organizations) === null || _a === void 0 ? void 0 : _a.length) !== null && _b !== void 0 ? _b : 0; },
        agreementStatus: function (item) { var _a; return "".concat((0, end2end_1.getCustomerExtendedAgreementStatus)(item), "--").concat((_a = (0, end2end_1.toDate)((0, utils_1.getAgreementDate)(item))) === null || _a === void 0 ? void 0 : _a.toJSON()); },
        clientDiscountSplit: function (item) { return item.accFirmDiscountSplit && (1 - item.accFirmDiscountSplit); },
        agreementDate: function (item) { var _a; return (_a = (0, end2end_1.toDate)((0, utils_1.getAgreementDate)(item))) === null || _a === void 0 ? void 0 : _a.toJSON(); },
    },
    sortMapper: {
        agreementStatus: Object.fromEntries(agreementStatusOrder.map(function (v, i) { return [v, i]; })),
    },
    cells: [
        {
            field: 'name',
            cell: { width: XL },
            truncate: {},
            footerAggregate: 'count',
            footerAggregateRenderValue: (0, FooterCounterWithWord_1.default)('customer'),
        },
        { fields: ['primaryContactName', 'primaryContactEmail'], cell: { width: LG } },
        {
            field: 'organizationsCount',
            cell: { width: LG, textAlign: 'center' },
            footerAggregate: 'sum',
            footerAggregateRenderValue: (0, FooterCounterWithWord_1.default)('organization'),
        },
        {
            fields: ['agreementStatus', 'agreementDate'],
            cell: { width: XL - 16, flexbox: true },
            renderComponent: AgreementStatus_1.default,
            footerAggregate: 'countGroups',
            footerAggregateRenderObj: StatusCounter_1.default,
        },
        {
            field: 'clientDiscountSplit',
            cell: { width: XL },
            truncate: {},
            renderField: function (v) { return v ? "".concat((0, end2end_1.formatPercentage)(v), " client | ").concat((0, end2end_1.formatPercentage)(1 - v), " firm") : 'Set by vendor split'; },
        },
        {
            key: 'actionsDropdown', cell: { width: XSM, isActionCell: true }, renderComponent: ActionsDropdown_1.default,
        },
    ],
};
